module.exports = __webpack_public_path__ + "static/blog_logo-d092ea54afe2fce305a1e715d3a03ada.jpg";